import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { GetParticipantInfoQueryResponse, GetParticipantInfoQueryParams } from "../../types/GetParticipantInfo";

/**
     * @link /api/purchase-tenders/v1/show_participant-info
     */
export async function getParticipantInfo (params: GetParticipantInfoQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<GetParticipantInfoQueryResponse>["data"]> {
    const { data: resData } = await client<GetParticipantInfoQueryResponse>({
        method: "get",
        url: `/api/purchase-tenders/v1/show_participant-info`,
        params,
        ...options
    });
    
    return resData;
};